// レコメンド共通処理用のjs（インプレッション、クリック時のEコマース設定など）
/**
 * レコメンドイベントを登録する
 * @param recommendId  レコメンドのid属性（他のレコメンドへ影響しないようにする）
 */
function registRecommendEvent(recommendId){
	// イベント再登録
	if (typeof trackEvent != 'undefined') {
		trackEvent.bindEventOnElements(recommendId);
	}

   // 拡張EC教室インプレッションイベント
	let recommendKousha = recommendId.find('.js-reco-ec-impression');
	if(recommendKousha.size()){
		let ecItemList = [];
		$.each(recommendKousha, function(i, val) {
			if (val.dataset.product_name == undefined) {return true;}
			let ecItem = {
				'item_id': val.dataset.product_name,
				'item_brand': val.dataset.product_brand,
				'item_category': val.dataset.product_category,
				'price': 4000,
				'currency': 'JPY',
				'item_list_name': ($(this).attr('list_name') != undefined) ? $(this).attr('list_name') : '',
				'index': ($(this).attr('list_position') != undefined) ? $(this).attr('list_position') : '',
				'quantity': 1
			};
			ecItemList.push(ecItem);
			
			// 送信単位ごとまたは最後なら送信
			if(i == recommendKousha.length - 1){
				gtag('event', 'kousha', {
					"TheEventAction": "impression",
					'non_interaction': true
				});
			}
		});
		gtag('event', 'view_item_list', {
			'items': ecItemList
		});
	} 

	// 拡張EC教室リンククリックイベント
	recommendId.find('.js-reco-ec-link').on('click', function(e) {
		// リンクを一旦無効にする
		e.preventDefault();
		// 遷移はhitCallbackで行う
		let url = $(this).attr('href');
		let target = $(this).attr('target');
		gtag('event', 'select_item', {
			"items": [{
				"item_id": $(this).data("product_name"),
				"item_category": $(this).data("product_category"),
				"item_brand": $(this).data("product_brand"),
				"index": ($(this).attr('list_position') != undefined) ? $(this).attr('list_position') : '',
				"item_list_name": ($(this).attr('list_name') != undefined) ? $(this).attr('list_name') : 'ec-link-click'
			}],
		});
		
		let located = false;
		function location(){
			if(!located){
				located = true;
				if (target == '_parent') {
					top.location.href = url;
				} else {
					document.location.href = url;
				}
			}
		}
		
		// タイムアウト処理
		setTimeout(location, 1000);

		gtag('event', 'link', {
			"TheEventAction": "click",
			'event_callback': function(){
				location();
			}
		});
	});

	// 拡張EC家庭教師インプレッションイベント
	let recommendTutor = recommendId.find('.js-reco-ec-tutor-impression');
	if(recommendTutor.size()){
		let ecItemList = [];
		$.each(recommendTutor, function(i, val) {
			if (val.dataset.recommend_tutor_id == undefined) { return true; }
			let ecItem = {
				'item_id': val.dataset.recommend_tutor_id,
				'item_brand': val.dataset.recommend_tutor_id,
				'item_category': val.dataset.recommend_tutor_id,
				'price': 4000,
				'currency': 'JPY',
				'item_list_name': this.dataset.recommend_tutor_list_name,
				'index': ($(this).attr('list_position') != undefined) ? $(this).attr('list_position') : '',
				'quantity': 1
			};
			ecItemList.push(ecItem);
		});
		gtag('event', 'view_item_list', {
			'items': ecItemList
		});
		
		gtag('event', 'recommend_tutor', {
			"TheEventAction": "impression",
			'non_interaction': true
		});
	}

	// 拡張EC家庭教師クリックイベント
	recommendId.find('.js-ec-reco-tutor-link').on('click', function() {
		gtag('event', 'select_item', {
			"items": [{
				"item_id": this.dataset.recommend_tutor_id,
				"item_category": this.dataset.recommend_tutor_id,
				"item_brand": this.dataset.recommend_tutor_id,
				"index": ($(this).attr('list_position') != undefined) ? $(this).attr('list_position') : '',
				"item_list_name":this.dataset.recommend_tutor_list_name
			}],
		});
		
		gtag('event', 'recommend_tutor', {
			"TheEventAction": "click",
			'non_interaction': true
		});
	});

	// チェックボックス
	recommendId.find('.js-reco-ec-checkbox').on('click', function() {
		let ecItem = {
			'item_id': this.dataset.product_name,
			'item_brand': this.dataset.product_brand,
			'item_category': this.dataset.product_category,
			'price': 4000,
			'currency': 'JPY',
			'item_list_name': ($(this).attr('list_name') != undefined) ? $(this).attr('list_name') : '',
			'index': ($(this).attr('list_position') != undefined) ? $(this).attr('list_position') : '',
			'quantity': 1
		};
		gtag('event', ($(this).is(':checked')) ? 'add_to_cart' : 'remove_from_cart', {
			'currency': 'JPY',
			'value': 4000,
			'items': [ecItem]
		});
		gtag('event', 'cart', {
			"TheEventAction": "cart",
		});
	});

	/** 重複するIDを番号付きIDに書き換える(モーダルウィンドウ複数対応) */
	let modal_count = 0;
	recommendId.find(".js-reco-modal-window").each(function(){
		modal_count += 1;
		$(this).find("#js-reco-modal-window-link").attr("id","js-reco-modal-window-link"+modal_count);
	});

	// 閉じるボタンでモーダルウィンドウを閉じる
	recommendId.find(".js-reco-modal-window-close").click(function() {
		// クリックしたボタンと同じ要素のモーダルウィンドウを閉じる
		modalArea = $(this).parents(".js-reco-modal-window");
		$(".js-reco-modal-window-box").fadeOut();
		modalArea.children(".js-reco-modal-window-box-inner").fadeOut();
		// スクロールを元に戻す
		$('body').css('overflow', 'auto');
		$('body').css('height', '');
		$('body').css('width', '');
		$('body').css('position', '');
		$('html').css('overflow', '');
		$('html').css('height', '');

		// iframeを開いている場合閉じる
		$(".js-reco-modal-window-cont-iframe").html('');			//iframeの内容を上書きして消す
	});

	/** オーバーレイクリックでモーダルウィンドウを閉じる */
	recommendId.find('.js-reco-modal-window-box').click(function() {
		// モーダルが表示しきっていないと無効
		if ($('.js-reco-modal-window-box').is(':visible') && $('.js-reco-modal-window-box-inner').is(':visible')) {
			$(".js-reco-modal-window-box:visible").fadeOut();
			$(".js-reco-modal-window-box-inner:visible").fadeOut();

			$('body').css('overflow', 'auto');
			$('body').css('height', '');
			$('body').css('width', '');
			$('body').css('position', '');
			$('html').css('overflow', '');
			$('html').css('height', '');

			// iframeを開いている場合閉じる
			$(".js-reco-modal-window-cont-iframe:visible").html('');			//iframeの内容を上書きして消す
		}
	});

	/** iframe対応版 */
	// モーダルウィンドウを開く
	recommendId.find(".js-reco-modal-window-btn-iframe").click(function() {
		
		// クリックしたボタンと同じ要素のモーダルウィンドウを開く
		modalArea = $(this).parents(".js-reco-modal-window");
		iframeHref = $(this).attr("href");
		iframeName = ($(this).attr("name") != undefined) ? $(this).attr("name") : '' ;
		modalArea.children(".js-reco-modal-window-box").fadeIn("fast", function() {
			// js-modal-window-box-innerを画面中央に配置するための幅の調整
			modalLeft = Math.floor(($(window).width() - modalArea.children(".js-reco-modal-window-box-inner").width()) / 2);
			modalTop = Math.floor(($(window).height() - modalArea.children(".js-reco-modal-window-box-inner").height()) / 2);

			modalArea.children(".js-reco-modal-window-box-inner").css({"top":modalTop, "left":modalLeft });
			modalArea.children(".js-reco-modal-window-box-inner").fadeIn().find(".js-reco-modal-window-cont-iframe").html('<iframe src="' + iframeHref + '" name="' + iframeName + '" style="width:100%; height:100%;"></iframe>');
			// スクロールさせない
			$('body').css('overflow', 'hidden');
		});
		return false;
	});

	// ifame内の閉じるボタンでモーダルウィンドウ(自分自身)を閉じる
	recommendId.find(".js-reco-modal-window-close").click(function() {
		// オーバーレイ部分をクリック
		parent.$('.js-reco-modal-window-box:visible').trigger('click');
	});
	/** iframe対応版 */

	recommendId.find('.js-cart-modal-window-open').on('click', function(){
		$('.js-cart-modal-window-' + $(this).attr('juku_id') + '-' + $(this).attr('kousha_id')).trigger('click');
	});
}